import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/AuthContext';

export function NotificationsRoute() {
  const { t } = useTranslation();
  const auth = useAuth();
  // Notifications API not wired yet — show an empty state for signed-in
  // users + the "what we'll alert you about" explainer (a positive frame
  // for the empty state, not a sad zero).
  const signedIn = Boolean(auth.user);

  return (
    <div className="mx-auto max-w-[640px] px-4 pb-16 pt-6">
      <h1 className="h1 m-0 mb-2">{t('nav.notifications')}</h1>
      <p className="muted m-0 mb-6 text-sm">{t('notifications.intro')}</p>

      <article className="rounded-lg border border-dashed border-[color:var(--border)] bg-[color:var(--bg-alt)] p-8 text-center">
        <div className="mb-3 text-5xl" aria-hidden="true">
          🔔
        </div>
        <h2 className="m-0 mb-1 text-xl font-bold">{t('notifications.none_yet_title')}</h2>
        <p className="m-0 text-sm text-ink-soft">{t('notifications.none_yet_body')}</p>
        {!signedIn && (
          <a
            href="/signin"
            className="mt-4 inline-flex min-h-[44px] items-center justify-center rounded-md bg-soi-600 px-4 py-2 text-sm font-semibold text-white"
          >
            {t('nav.signin')}
          </a>
        )}
      </article>

      <section className="mt-10">
        <h2 className="m-0 mb-3 text-xl font-bold">{t('notifications.what_we_send')}</h2>
        <ul className="m-0 list-disc space-y-1 pl-5 text-ink-soft">
          <li>{t('notifications.bullets.favorite_opened')}</li>
          <li>{t('notifications.bullets.submission_approved')}</li>
          <li>{t('notifications.bullets.badge_unlocked')}</li>
          <li>{t('notifications.bullets.weekly')}</li>
        </ul>
        <p className="mt-3 text-[12px] text-ink-muted">{t('notifications.promise')}</p>
      </section>
    </div>
  );
}
